// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"554":"c99c126d6b420518","888":"f6d523fcde3ccb8e"}[chunkId] + ".css";
};